import React, { useEffect, useState } from 'react';
import { useDrag } from 'react-dnd';
import Skeleton from 'react-loading-skeleton';
import { Input } from '../Input';
import { HeroIcons } from '../style/heroicons';
import { Text, TextType } from '../Text';
import { appendClassProps } from '../util';
function SearchableListItem({ component, id, label, value, loading, handleClickOption }) {
    return !!component ? (React.createElement("div", { key: id, className: `cursor-pointer`, onClick: () => {
            if (id && handleClickOption)
                handleClickOption(id);
        } }, component)) : (React.createElement("div", { key: id, className: `cursor-pointer ${id === value && !loading ? 'text-white bg-blue-800' : 'text-blue-800'} hover:bg-blue-800 hover:text-white`, onClick: () => {
            if (id && handleClickOption)
                handleClickOption(id);
        } }, loading ? (React.createElement(Skeleton, null)) : (React.createElement(Text, { type: TextType.body, overrideColor: true }, label))));
}
function DraggableSearchableListItem({ component, id, label, value, draggableType, loading, onDragStateChange, handleClickOption }) {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: draggableType || 'SearchableListItem',
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        }),
        item: {
            id
        }
    }));
    useEffect(() => {
        if (onDragStateChange)
            onDragStateChange(isDragging);
    }, [isDragging]);
    return !!component ? (React.createElement("div", { ref: drag, key: id, className: `cursor-pointer`, onClick: () => {
            if (id && handleClickOption)
                handleClickOption(id);
        } }, component)) : (React.createElement("div", { ref: drag, key: id, className: `cursor-pointer ${id === value && !loading ? 'text-white bg-blue-800' : 'text-blue-800'} hover:bg-blue-800 hover:text-white`, onClick: () => {
            if (id && handleClickOption)
                handleClickOption(id);
        } }, loading ? (React.createElement(Skeleton, null)) : (React.createElement(Text, { type: TextType.body, overrideColor: true }, label))));
}
/**
 - Use SearchableList to select from a long list of scrollable options
 */
export const SearchableList = ({ options, className, value, draggable, draggableType, loading, onDragStateChange, onSelect }) => {
    const [displayedOptions, setDisplayedOptions] = useState(options);
    useEffect(() => {
        setDisplayedOptions(options);
    }, [options]);
    const handleChangeSearch = (text) => {
        setDisplayedOptions(options.filter(({ label }) => label.toLowerCase().includes(text.toLowerCase())));
    };
    const handleClickOption = (key) => {
        onSelect(key);
    };
    return (React.createElement("div", { className: `flex flex-col overflow-hidden${appendClassProps(className)}`, "data-testid": "searchableList" },
        React.createElement(Input, { leftIcon: HeroIcons.SearchIcon, onChangeValue: handleChangeSearch }),
        React.createElement("div", { className: `flex flex-col ${loading ? '' : 'overflow-y-auto '}gap-2` }, loading
            ? [...Array(5)].map(() => React.createElement(SearchableListItem, { loading: true }))
            : displayedOptions?.map(({ id, label, component }) => {
                return draggable ? (React.createElement(DraggableSearchableListItem, { key: id, id: id, label: label, component: component, handleClickOption: handleClickOption, value: value ?? '', draggableType: draggableType, onDragStateChange: onDragStateChange })) : (React.createElement(SearchableListItem, { key: id, id: id, label: label, component: component, handleClickOption: handleClickOption, value: value ?? '' }));
            }))));
};
export * from './index.types';
//# sourceMappingURL=index.js.map